import { CommonGet, CommonPost } from '../../../utils/CommonFetch';
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    saveFactoryItems,
    getAllByFilter,
    //getFactoryItemsByFilters,
    editData,
    getGroups,
    //getProducts,
    getOperationCards,
    getCollectionPointByGroupEntityID,
    getOperationalEntityByGroupEntityID,
    getEntityTypes,
    getCollectionPoints,
    updateFactoryItems,
    getAllActiveItemCategory
};


async function saveFactoryItems(data) {
 
     var dataModel = {
        factoryItemID: data.factoryItemID,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
       // productID: parseInt(data.productID),
        factoryItemCode: data.factoryItemCode.trim(),
        factoryItemName: data.factoryItemName.trim(),
        factoryItemDescription: data.factoryItemDescription,
        //price: parseFloat(data.price),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString(),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        measuringUnit: parseInt(data.measuringUnit),
        itemCategoryID: parseInt(data.itemCategoryID)
      }

    var result = await CommonPost('/api/FactoryItem/InsertFactoryItem',null, dataModel);

    return result;

}


async function updateFactoryItems(data) {
    var response = await CommonPost('/api/FactoryItem/UpdateFactoryItem', null, data);
    return response
}


async function getAllByFilter(groupid, factoryId) {
    var response = await CommonGet('/api/FactoryItem/GetFactoryItemByFilter', 'groupID=' + groupid + '&entityID=' + factoryId );
    return response.data;
}

/*async function getFactoryItemsByFilters(groupID, factoryID, collectionPointId) {
    var response = await CommonGet('/api/FactoryItem/GetFactoryItemsGridAddEdit', 'groupId=' + groupID + '&factoryID=' + factoryID + '&collectionPointId=' + collectionPointId + '&productId=' + productId);
    return response.data;
}*/

 async function editData(data) {
    var dataModel = {
        factoryItemID: data.factoryItemID,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        productID: parseInt(data.productID),
        factoryItemCode: data.factoryItemCode.trim(),
        factoryItemName: data.factoryItemName.trim(),
        factoryItemDescription: data.factoryItemDescription,
        price: parseFloat(data.price),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString(),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        measuringUnit: parseInt(data.measuringUnit),
        itemCategoryID: parseInt(data.itemCategoryID)
    }

     var result = await CommonPost('/api/FactoryItem/UpdateFactoryItem', null, dataModel);

    return result;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getCollectionPoints() {
    var response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    return response.data;
}

async function getEntityTypes() {
    let response = await CommonGet('/api/OperationEntity/GetAllEntities', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["entityTypeID"]] = item[1]["entityTypeName"]
        }
    }
    return array;
}

async function getOperationalEntityByGroupEntityID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}


/*async function getProducts(entityId) {
    var response = await CommonGet('/api/OperationentityProductMapping/FilterProductsByOperationEntity', 'entityId=' + entityId);
    var array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["productID"]] = item[1]["productName"]
    }
    return array;
}*/

async function getCollectionPointByGroupEntityID(groupID, entityID) {
    const response = await CommonGet('/api/CollectionPoint/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID + '&entityID=' + entityID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return array;
}

async function getAllActiveItemCategory() {
    const response = await CommonGet('/api/FactoryItemCategory/GetAllActiveItemCategory', null);

    console.log(response);
  
    let factoryArray = []
    for (let item of Object.entries(response.data)) {
      factoryArray[item[1]["itemCategoryID"]] = item[1]["categoryName"]
    }
  
    return factoryArray;
  }

function getOperationCards() {
    const expopCardDropDownData = {
        2: "1",
        3: "2",
        4: "3"
    }
    return expopCardDropDownData;
}